<template>
  <div id="wrapper">
    <SideNav />

    <div id="content-wrapper" class="d-flex flex-column">
      <div id="content">
        <Navbar />
        <div class="container-fluid mt-4">
          <slot />
          <UpdatePassword />
          <showProfile />
        </div>
      </div>
      <div id="overlay">
        <font-awesome-icon class="loading-icon" icon="spinner" size="2x" pulse />
      </div>
      <!--<Footer />-->
    </div>
  </div>
</template>

<script>
import Footer from "@/layouts/Footer";
import Navbar from "@/layouts/NavbarDashboard";
import SideNav from "@/layouts/SideNav";
import UpdatePassword from "@/layouts/UpdatePassword";
import showProfile from "@/layouts/showProfile";

export default {
  name: "Dashboard",
  components: { Navbar, SideNav, Footer, UpdatePassword, showProfile }
};
</script>



// WEBPACK FOOTER //
// src/layouts/Dashboard.vue